<app-grid-modal
  i18n-header
  header="Stock Items for Product"
  [columnDefs]="columnDefs"
  [summaryTop]="summaryItem"
  [rowData$]="rowData$"
  [showDelete]="showDelete"
  [summaryItems]="summaryItems"
></app-grid-modal>
